import { LocalSelectionCategories } from '../types/filters';

const FLIGHT_RISK_SELECTION_LIST = {
  list: [
    {
      id: '0',
      label: 'Very Low',
      shortName: 'Very Low',
    },
    {
      id: '1',
      label: 'Low',
      shortName: 'Low',
    },
    {
      id: '2',
      label: 'Medium',
      shortName: 'Medium',
    },
    {
      id: '3',
      label: 'High',
      shortName: 'High',
    },
    {
      id: '4',
      label: 'Very High',
      shortName: 'Very High',
    },
  ],
};

const PRESTIGE_SELECTION_LIST = {
  list: [
    {
      id: '0',
      label: 'Very Low',
      shortName: 'Very Low',
    },
    {
      id: '1',
      label: 'Low',
      shortName: 'Low',
    },
    {
      id: '2',
      label: 'Medium',
      shortName: 'Medium',
    },
    {
      id: '3',
      label: 'High',
      shortName: 'High',
    },
    {
      id: '4',
      label: 'Very High',
      shortName: 'Very High',
    },
  ],
};

const REMOTE_SUITABILITY_SELECTION_LIST = {
  list: [
    {
      id: '0',
      label: 'Very Low',
      shortName: 'Very Low',
    },
    {
      id: '1',
      label: 'Low',
      shortName: 'Low',
    },
    {
      id: '2',
      label: 'Medium',
      shortName: 'Medium',
    },
    {
      id: '3',
      label: 'High',
      shortName: 'High',
    },
    {
      id: '4',
      label: 'Very High',
      shortName: 'Very High',
    },
  ],
};

export const ALL_STATIC_SELECTION_LISTS = [
  {
    id: LocalSelectionCategories.FLIGHT_RISK,
    value: FLIGHT_RISK_SELECTION_LIST.list,
  },
  {
    id: LocalSelectionCategories.PRESTIGE,
    value: PRESTIGE_SELECTION_LIST.list,
  },
  {
    id: LocalSelectionCategories.REMOTE_SUITABILITY,
    value: REMOTE_SUITABILITY_SELECTION_LIST.list,
  },
];
